"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ADVANCED_CHOICE_KEY = exports.DEFAULT_CHOICE_KEY = exports.ADVANCED_CHOICE_KEYS = exports.CHOICE_KEYS = exports.EnrollmentStatus = void 0;
exports.isChoiceKey = isChoiceKey;
exports.isAdvancedChoiceKey = isAdvancedChoiceKey;
exports.toChoiceKey = toChoiceKey;
exports.toAdvancedChoiceKey = toAdvancedChoiceKey;
/** 报名状态，与 `nup_enrollment.status` 一致。 */
var EnrollmentStatus;
(function (EnrollmentStatus) {
    /** 进行中，入金期内可各提交一次入门 4 选 1 / 进阶 3 选 1 */
    EnrollmentStatus[EnrollmentStatus["IN_PROGRESS"] = 0] = "IN_PROGRESS";
    /** 结算中（CAS，任务可重入） */
    EnrollmentStatus[EnrollmentStatus["SETTLING"] = 1] = "SETTLING";
    /** 已向 benefit 提交发奖 */
    EnrollmentStatus[EnrollmentStatus["AWARDED"] = 2] = "AWARDED";
    /** 无入金流水，可再报 */
    EnrollmentStatus[EnrollmentStatus["RE_ENROLLABLE"] = 3] = "RE_ENROLLABLE";
    /** 有入金但未达门槛 */
    EnrollmentStatus[EnrollmentStatus["BELOW_THRESHOLD"] = 4] = "BELOW_THRESHOLD";
})(EnrollmentStatus || (exports.EnrollmentStatus = EnrollmentStatus = {}));
exports.CHOICE_KEYS = [
    'nvidia',
    'btc',
    'voucher',
    'hsbc',
];
exports.ADVANCED_CHOICE_KEYS = [
    'nvidia',
    'btc',
    'hsbc',
];
/** 入门赏未选时的结算默认。 */
exports.DEFAULT_CHOICE_KEY = 'nvidia';
/** 进阶赏未选时的结算默认。 */
exports.DEFAULT_ADVANCED_CHOICE_KEY = 'nvidia';
function isChoiceKey(value) {
    return exports.CHOICE_KEYS.includes(value);
}
function isAdvancedChoiceKey(value) {
    return exports.ADVANCED_CHOICE_KEYS.includes(value);
}
/** 库内空值 / 非法值视为未选。 */
function toChoiceKey(value) {
    if (!value || !isChoiceKey(value)) {
        return null;
    }
    return value;
}
/** 进阶赏三选一；超市礼券非法。 */
function toAdvancedChoiceKey(value) {
    if (!value || !isAdvancedChoiceKey(value)) {
        return null;
    }
    return value;
}
